import { createContext, useContext } from "react"

interface JobPreviewCardContextValue {
    isLoading: boolean
}

const JobPreviewCardContext = createContext<JobPreviewCardContextValue | undefined>(undefined)

export const JobPreviewCardProvider = JobPreviewCardContext.Provider

export function useJobPreviewCard() {
    const context = useContext(JobPreviewCardContext)
    if (!context) {
        throw new Error("useJobPreviewCard must be used within a JobPreviewCardProvider")
    }
    return context
}
